export interface CatalogTundishShroud {
  TundishShroudId: number | null;
  TundishShroudName: string;
  Enabled: boolean;
  IsActive: boolean;
}
export const CATALOG_TUNDISH_SHROUD_INITIAL_VALUES: CatalogTundishShroud = {
  TundishShroudId: null,
  TundishShroudName: "",
  Enabled: true,
  IsActive: true,
};
